import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DealModel } from 'ts/package/interfaces/PackageOfflineResponse';
import BookSummary from './BookSummary';
import SuccessPassengerDetails from '../Book/SuccessPassengerDetails';
import { delay, getBase64Screenshot } from 'utils/utils';
import { submitOfflineScreenshots } from 'services/package';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { needToScreenshot } from 'constants/generic';

const PackageOfflineSuccessPage: FC = () => {
  const [t] = useTranslation();
  const successRef = useRef<HTMLDivElement>(null);
  
  useGetPage('ILPackage/BookComplete');

  const [order, setOrder] = useState<DealModel>();

  useEffect(() => {
    const orderStr = sessionStorage.getItem('offPackageSuccessOrder');
    if (orderStr) {
      const order = JSON.parse(orderStr);
      setOrder(order);
      (async () => {
        await delay(1000);

        if (needToScreenshot && !order.screenshot) {
          const image = await getBase64Screenshot(successRef.current);

          submitOfflineScreenshots({
            screenshots: [],
            orderId: order.orderId,
            lastScreenshot: image,
          });
          sessionStorage.setItem(
            'offPackageSuccessOrder',
            JSON.stringify({ ...order, screenshot: true })
          );
        }
      })();
    }
  }, []); // eslint-disable-line

  return (
    <div className="success page-wrapper" ref={successRef}>
      <div className="title">
        {t('flight.order_summary')} #{order?.orderId}
      </div>
      {order?.statusIsOK ? (
        <div className="text-md mb-20">{t('success')}!</div>
      ) : (
        <div className="mb-20">
          <FontAwesomeIcon className="color-danger mr-5" icon={faExclamationTriangle} />
          <span className="text-md">{t('failed_order')}</span>
        </div>
      )}
      {order?.orderHasBeenPaid && (
        <div className="text-md mb-20">{t('hotel.paid_successfully')}</div>
      )}
      {!!order && <SuccessPassengerDetails paxes={order.paxes as any} />}
      {!!order && (
        <BookSummary deal={order} successPage={true} couponAmount="" setCouponAmount={() => {}} />
      )}
    </div>
  );
};

export default withErrorBoundary(PackageOfflineSuccessPage, 'PackageOfflineSuccessPage');
